import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useRegistrationForm } from "../provider/registrationFormProviderContext";
import { RegistrationDefaultEndPage } from "./RegistrationDefaultEndPage";

export const RegistrationCancelledPage = () => {
	const { t } = useTranslation();
	const { registrationForm } = useRegistrationForm();
	const navigate = useNavigate();

	if (!registrationForm.isCancelable) {
		navigate("../landing-page");
	}

	return (
		<RegistrationDefaultEndPage
			headline={t("Cancellation confirmed")}
			text={t("Thank you for letting us know that unfortunately you will not be able to attend after all.")}
			blockId={registrationForm.cancelledBlockId}
		/>
	);
};
